var Observable_1 = require('../../Observable');
var defaultIfEmpty_1 = require('../../operator/defaultIfEmpty');
Observable_1.Observable.prototype.defaultIfEmpty = defaultIfEmpty_1.defaultIfEmpty;
//# sourceMappingURL=defaultIfEmpty.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/defaultIfEmpty.js
 ** module id = 341
 ** module chunks = 1
 **/